// src/app/Routes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import ProtectedRoute from "../components/common/ProtectedRoute";
import DebugInfo from "../components/common/DebugInfo";

// Auth Pages
import LoginPage from "../features/auth/pages/LoginPage";
import RegisterPage from "../features/auth/pages/RegisterPage";
import ForgotPassword from "../features/auth/components/ForgotPassword";

// Feature Pages
import DashboardPage from "../features/dashboard/pages/DashboardPage";
import GalleryPage from "../features/publicGallery/pages/GalleryPage";
import InvoicePage from "../features/invoice/pages/InvoicePage";
import QuotationPage from "../features/quotation/pages/QuotationPage";
import BlogPage from "../features/blog/pages/BlogPage";
import PrivateAlbumPage from "../features/privateAlbum/pages/PrivateAlbumPage";
import EventPage from "../features/eventManagement/pages/EventPage";
// Optional: Client and File Manager Pages (if you have them)
// import ClientPage from "../features/client/pages/ClientPage";
// import FileManagerPage from "../features/fileManager/pages/FileManagerPage";
import InvitationPage from "../features/invitations/pages/InvitationPage";
import InvitationView from "../features/invitations/pages/InvitationView";
import CRMPage from "../features/crm/pages/CRMPage";
import AccountsPage from "../features/accounts/pages/AccountsPage";
const AppRoutes = () => {
  return (
    <Routes>
      {/* Debug Route - for development only */}
      <Route path="/debug" element={<DebugInfo />} />

      {/* Auth Routes - Public */}
      <Route
        path="/login"
        element={
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        }
      />
      <Route
        path="/register"
        element={
          <AuthLayout>
            <RegisterPage />
          </AuthLayout>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <AuthLayout>
            <ForgotPassword />
          </AuthLayout>
        }
      />

      {/* Protected Routes - Require Authentication */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        {/* Default redirect to dashboard */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="private-albums" element={<PrivateAlbumPage />} />
        <Route path="public-galleries" element={<GalleryPage />} />
        {/* Dashboard */}
        <Route path="dashboard" element={<DashboardPage />} />
        {/* Gallery Management */}
        <Route path="gallery" element={<GalleryPage />} />

        {/* Invoice Management */}
        <Route path="invoices" element={<InvoicePage />} />
        <Route path="invitations" element={<InvitationPage />} />

        <Route path="/i/:invitationId" element={<InvitationView />} />
        <Route path="events" element={<EventPage />} />
        <Route path="crm" element={<CRMPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        {/* Quotation Management */}
        <Route path="quotations" element={<QuotationPage />} />
        <Route path="blog" element={<BlogPage />} />
        {/* Optional: Client Management */}
        {/* <Route path="clients" element={<ClientPage />} /> */}
        {/* Optional: File Manager */}
        {/* <Route path="files" element={<FileManagerPage />} /> */}
      </Route>

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
